export const TIMEOUT = {
  ONE_SECOND: 1000,
  TWO_SECONDS: 2000,
  HALF_SECOND: 500,
  ONE_FIFTH_OF_SECOND: 200,
  ONE_TENTH_OF_SECOND: 100,
} as const;

export type ITimeout = (typeof TIMEOUT)[keyof typeof TIMEOUT];
